export default __webpack_public_path__ + "images/7a832e22c2b16eb4d7d3b640a8c96b2a-mc@2x.png";